import React from "react";
import { t } from "i18next";
import { usePWAInstall } from "react-use-pwa-install";

import { usePwa } from "@hooks/usePwa/usePwa";
import commonUtils from "@utils/common.utils";

const InstallPwa: React.FC = () => {
  const install = usePWAInstall();
  const { closePwaBanner } = usePwa();

  const installPwa = () => {
    install?.()
      .then(closePwaBanner)
      .catch(() => commonUtils.toastService(t("appInstallationFailed")));
  };

  return (
    <div className="fg-webapp-popup-download" data-testid="installpwa-test">
      <button
        className="btn fg-btn fg-btn-border-mediumgrey fg-btn-webapp-install"
        onClick={installPwa}
      >
        {t("installIcon")}
        <img
          src="/assets/images/download-icon.svg"
          width="24"
          alt="install Icon"
        />
      </button>
    </div>
  );
};

export default InstallPwa;
